import { StoreCreatingPromise } from 'store/storeCreator';

import Emitter from 'Emitter';

export class McsApi extends Emitter {
    async ready() {
        await StoreCreatingPromise;
        this.getUserApi = async () => {
            if (!this.user) {
                const { McsUserApi } = await import('./McsUserApi');
                this.user = new McsUserApi();
            }
            return this.user;
        };
        this.getAuthApi = async () => {
            if (!this.auth) {
                const { McsAuthApi } = await import('./McsAuthApi');
                this.auth = new McsAuthApi();
            }
            return this.auth;
        };
        this.getPricingApi = async () => {
            if (!this.pricing) {
                const { McsPricingApi } = await import('./McsPricingApi');
                this.pricing = new McsPricingApi();
            }
            return this.pricing;
        };
        this.getSellingApi = async () => {
            if (!this.selling) {
                const { McsSellingApi } = await import('./McsSellingApi');
                this.selling = new McsSellingApi();
            }
            return this.selling;
        };
        this.getPartnerApi = async () => {
            if (!this.partner) {
                const { McsPartnerApi } = await import('./McsPartnerApi');
                this.partner = new McsPartnerApi();
            }
            return this.partner;
        };
    }
}
